import React from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import AllGamesContent from '../../components/AllGamesContent';

const AllGamesPage = () => {
  return (
    <ProfileLayout activeItem="allgames">
      <AllGamesContent />
    </ProfileLayout>
  );
};

export default AllGamesPage;

